import React from 'react';
import Modal from '../../../shared/components/modals/Modal';
import './DeviceAuditHelpModal.css';

export default function DeviceAuditHelpModal({ isOpen, onClose, variant = 'admin' }) {
  const isSuperAdmin = variant === 'superadmin';
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Device audit & compliance" size="large">
      <div className="da-help">
        <p className="da-help__lead">
          {isSuperAdmin ? (
            <>
              Metrics in this section are <strong>organization-wide</strong> (all locations).
              Device audit activity covers the <strong>last 30 days</strong>; compliance rates
              reflect current device status.
            </>
          ) : (
            <>
              Metrics in this section are scoped to <strong>this location</strong>. Device audit
              activity covers the <strong>last 30 days</strong>; compliance rates reflect current
              device status.
            </>
          )}
        </p>

        <section>
          <h3>Device audit metrics</h3>
          <ul className="da-help__list">
            <li>
              <strong>Devices audited</strong> — distinct devices with at least one audit event
              in the last 30 days.
            </li>
            <li>
              <strong>New / Modified / Deleted</strong> — action counts in the window. These may
              add up to more than devices audited because one device can be created, updated, and
              deleted in the same period.
            </li>
            <li>
              <strong>Suspicious</strong> — active devices with more than 5 changes within 24
              hours (unusual change pattern). Review the recent changes list when this is non-zero.
            </li>
            <li>
              <strong>Compliance-impacting</strong> — changes touching PPM, calibration, or
              regulatory due dates or requirements.
            </li>
          </ul>
        </section>

        <section>
          <h3>Compliance rates</h3>
          <ul className="da-help__list">
            <li>
              <strong>PPM compliance</strong> — share of devices with PPM requirements that are
              currently compliant.
            </li>
            <li>
              <strong>Calibration</strong> — share of devices requiring calibration that are
              compliant.
            </li>
            <li>
              <strong>Regulatory</strong> — share of devices with regulatory compliance
              requirements that are compliant.
            </li>
            <li>
              Color thresholds: green at 80% or above, amber at 60–79%, red below 60%.
            </li>
            <li>
              <strong>N/A</strong> — no devices in scope to calculate the rate (e.g. no devices
              requiring that compliance type).
            </li>
          </ul>
        </section>

        <section>
          <h3>When to act</h3>
          <ul className="da-help__list">
            <li>Suspicious events &gt; 0 — review recent changes and affected devices.</li>
            <li>
              Compliance rate below 80% — check non-compliant devices and the
              {isSuperAdmin ? ' location' : ' department'} breakdown.
            </li>
            <li>Many deletions or compliance-impacting edits — verify authorization and audit trail.</li>
          </ul>
        </section>
      </div>
    </Modal>
  );
}
